import moment from 'moment';
import * as Yup from 'yup';
import { Relationship } from "../store/medicalAppointment/types";
export const validateDependentAge = (value: string, test : Yup.TestContext): Yup.ValidationError => {
    const { path, createError, parent } = test;
    let typeRelationShip: string = parent.relationship ;
    if (typeRelationShip !== undefined) {
        if (moment(value) > moment()) {
            return createError({ path, message: "La fecha no puede ser mayor a la actual" });
        }
        else {
            switch (typeRelationShip) {
                case Relationship.Hijos:
                    if (moment().diff(moment(value), 'years') > 23) {
                        return createError({ path, message: "El hijo/hija no debe ser mayor a 23 años" });
                    }
                    break;
                case Relationship.Conyuge:
                    if (moment().diff(moment(value), 'years') > 70) {
                        return createError({ path, message: "El cónyuge no debe ser mayor a 70 años" });
                    }
                    break;
                case Relationship.Titular:
                    if (moment().diff(moment(value), 'years') > 70) {
                        return createError({ path, message: "El titular no debe ser mayor a 70 años" });
                    }
                    break;
            }
        }
    }
    else {
          return createError({ path, message: "Debe seleccionar un parentesco!" });
    }
    return createError({path, message: ""});
};


export const validateRelationship = (value: string, existsPartner: boolean): boolean => {
    if (value !== undefined) {
        if (existsPartner && value  === Relationship.Conyuge) {
            return false;
        }
        else {
            return true;
        }
    }
    return true;
};

export const validateIdentification = (existsIdentification: boolean, operationType: string): boolean => {
    if (operationType === "1"){
        if (existsIdentification) {
            return false;
        }
        else {
            return true;
        }
    }
    else {
        return true;
    }
};
